import { type ColumnData } from "~/features/search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/ColumnConfigurator";
import type { orderColumnPreferences } from "../../models/orderbookModels";

export const getDefaultColumnConfig = (
  headerT: (key: string) => string,
  preferences?: orderColumnPreferences[],
): ColumnData[] => {
  const defaults: ColumnData[] = [
    { code: "salesOrderNo", visible: true, label: headerT("salesOrderNo") },
    {
      code: "purchaseOrderNo",
      visible: true,
      label: headerT("purchaseOrderNo"),
    },
    { code: "productDesignation", visible: true, label: headerT("product") },
    { code: "schaefflerId", visible: true, label: headerT("schaefflerId") },
    { code: "packaging", visible: true, label: headerT("packaging") },
    { code: "quantity", visible: true, label: headerT("quantity") },
    { code: "netPrice", visible: true, label: headerT("netPriceHeader") },
    { code: "netValue", visible: true, label: headerT("netValue") },
    { code: "deliveryDate", visible: true, label: headerT("deliveryDate") },
    {
      code: "requestedDeliveryDate",
      visible: true,
      label: headerT("reqDeliveryDate"),
    },
    { code: "actions", visible: true, label: "" },
  ];

  if (!preferences || preferences.length === 0) {
    return defaults;
  }

  const defaultMap = new Map(defaults.map((c) => [c.code, c]));

  const orderedColumns: ColumnData[] = preferences
    .map((pref) => {
      const col = defaultMap.get(pref.code);
      if (!col) {
        return null;
      }
      return {
        ...col,
        visible: pref.isVisible,
      };
    })
    .filter(Boolean) as ColumnData[];

  defaults.forEach((col) => {
    if (!orderedColumns.find((c) => c.code === col.code)) {
      orderedColumns.push(col);
    }
  });

  return orderedColumns;
};
